import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 4H2v16h20V4zM4 9h10.5v3.5H4V9zm0 5.5h10.5V18H4v-3.5zM20 18h-3.5V9H20v9z"
}), 'WebSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/WebSharp.js
// module id = 7253
// module chunks = 2